// Update menu comopnents for styling.
const navWrapper = document.querySelector('.mobile-menu');
const navToggle = navWrapper.querySelector('.elementor-menu-toggle');
const navDropdown = navWrapper.querySelector('.elementor-nav-menu--dropdown.elementor-nav-menu__container');

navToggle.addEventListener('click', () => {
    document.documentElement.classList.toggle('menu-is-open');
});

window.addEventListener('resize', () => {
    document.documentElement.classList.remove('menu-is-open');
    navToggle.classList.remove('elementor-active');
    navToggle.setAttribute('aria-expanded', 'false');
    navDropdown.setAttribute('aria-hidden', 'true');
});
